var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isClient)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content-wrapper bg-light"},[_c('div',{staticClass:"container"},[_c('router-view')],1)]),_vm._v(" "),(_vm.modal === 'newEstimate')?_c('NewEstimateModal'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }